import Cookies from "js-cookie";

export class CookieStorage implements Storage {
  private readonly prefix: string;

  constructor(prefix?: string) {
    this.prefix = prefix || "advanced-storage";
  }

  clear() {
    const allCookies = Cookies.get();
    for (const key in allCookies) {
      if (key.startsWith(this.prefix)) {
        Cookies.remove(key);
      }
    }
  }

  getItem(key: string) {
    return Cookies.get(`${this.prefix}${key}`) || null;
  }

  key(index: number) {
    const allKeys = Object.keys(Cookies.get() || {}).filter((key) =>
      key.startsWith(this.prefix)
    );

    return allKeys[index] || null;
  }

  removeItem(key: string) {
    Cookies.remove(`${this.prefix}${key}`);
  }

  setItem(key: string, value: string) {
    Cookies.set(`${this.prefix}${key}`, value);
  }

  get length() {
    return Object.keys(Cookies.get() || {}).filter((key) =>
      key.startsWith(this.prefix)
    ).length;
  }
}
